import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import uz from '@/locales/uz/main.json';
import ru from '@/locales/ru/main.json';

export default () => {
    i18n
        .use(initReactI18next)
        .init({
            fallbackLng: 'uz',
            debug: false,
            resources: {
                uz: { translation: uz },
                ru: { translation: ru },
            },
            interpolation: { escapeValue: false },
        });

    return i18n;
};
